import React, { useState, useContext } from "react"
import {
    Grid,
    TextField,
    CircularProgress
} from "@mui/material"
import { Autocomplete } from '@material-ui/lab'
import { useSelector } from "react-redux"
import TLServiceComponent from "../../../../../contexts/TLServiceComponent"
import { useAutoCompleteStyles } from "../../../../../utils"
import { useTheme } from "@material-ui/styles"
import config from "../../../../../config"

const SearchUGCForm = ({ translate, ugc, addRight }) => {
    const { theme: { bgColors, colors } } = useTheme()  
    const [founded, setFounded] = useState([])
    const [selected, setSelected] = useState(null)
    const [loading, setLoading] = useState(false)
    const token = useSelector((state) => state.userData.token)
    const tlService = useContext(TLServiceComponent)
    const themeState = useSelector(state => state.userData.theme || localStorage.getItem('theme') || config.THEMES_MODES.LIGHT)
    const isContrast = themeState !== config.THEMES_MODES.LIGHT
    const classes = useAutoCompleteStyles(bgColors, colors)()

    const handleInputChange = async (_, value, reason) => {
        if (reason === 'input' && value.length > 1) {
            setLoading(true)
            let res = [[], []]
            try {
                switch (ugc) {
                    case 0:
                        res[0] = await tlService.getFilteredUsers(token, {}, { email: `%${value}%` })
                        res[1] = await tlService.getFilteredUsers(token, {}, { user_name: `%${value}%` })
                        break
                    case 1:
                        res[0] = await tlService.getFilteredGroups(token, {}, { name: `%${value}%` })
                        break
                    case 2:
                        res[0] = await tlService.getFilteredCompanies(token, {}, { name: `%${value}%` })
                        break
                    default:
                        return
                }

                let listResult = []
                if (res[0]?.data) listResult = [...res[0].data]
                if (res[1]?.data) {
                    const filtered = res[1].data.filter(
                        value1 => listResult.findIndex(value2 => value2.id === value1.id) === -1
                    )
                    listResult = listResult.concat(filtered)
                }

                setFounded(listResult)
            } catch (e) {
                setFounded([])
            }
            setLoading(false)
        } else if (value.length <= 1) {
            setFounded([])
        }
    }

    const handleSelectUser = (_, newValue) => {
        if (newValue && newValue.id) {
            const newRight = [
                newValue.id,
                ugc === 0 ? newValue.user_name : newValue.name
            ]
            setSelected(newValue)
            addRight(newRight)
        } else {
            setSelected(null)
            addRight(false)
        }
    }

    return (
        <Grid container spacing={2} alignItems="center" justifyContent='center' padding={1}>
            <Grid item xs={12} md={9}>
                <Autocomplete
                    fullWidth
                    size="small"
                    style={{ width: 200, height: '52px' }}
                    classes={{
                        paper: isContrast ? classes.paper : '',
                        option: isContrast ? classes.option : '',
                        clearIndicator: isContrast ? classes.clearIndicator : '',
                        noOptions: isContrast ? classes.noOptions : '',
                        popupIndicator: isContrast ? classes.popupIndicator : '',
                    }}
                    options={founded}
                    loading={loading}
                    value={selected}
                    onChange={handleSelectUser}
                    onInputChange={handleInputChange}
                    getOptionLabel={(option) =>
                        typeof option === 'string' ? option : (ugc === 0 ? option.user_name : option.name || "")
                    }
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                    noOptionsText={translate("admin_texttype_ugc-search-no-options")}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={translate("admin_texttype_ugc-search-select")}
                            variant="outlined"
                            InputLabelProps={{ style: { fontSize: 15, color: colors.colorMutedText}, shrink: true }}
                            InputProps={{
                                ...params.InputProps,
                                style: {color: colors.colorText, backgroundColor: bgColors.bgPrimary200},
                                endAdornment: (
                                    <>
                                        {loading ? <CircularProgress style={{color: colors.colorText}} size={20} /> : null}
                                        {params.InputProps.endAdornment}
                                    </>
                                ),
                            }}
                        />
                    )}
                />
            </Grid>
        </Grid>
    )
}

export default SearchUGCForm
